module.exports = __webpack_public_path__ + "media/images/my_apps/ohap_my_apps_anatomy_physiology_banner_2018-5e98ea8b877f184b664ff9356451583b.png";